import { Link } from "react-router-dom";
import { Paths } from "./../constants/UrlConstants";
import React from "react";
import MedExpertBannerSrc from "../assets/img/card-images/Ask-A-Medical-Expert_1112x646.jpg";
import MedExpertPromoSrcMobile from "../assets/img/card-images/Ask-A-Medical-Expert_580x340.jpg";
import MedExpertBannerHolSrc from "../assets/img/hol/doctor.jpg";
import layoutStyle from "../assets/css/modules/shared/layout.css";
import { RebrandHelper } from "../helpers/brand/RebrandHelper";
import linkStyles from "../assets/css/modules/shared/link.css";

const GenericHelpSet = [
  {
    Question: "How do I authorise a new treatment?",
    Answer: {
      Any: (
        <p>
          If you have a new treatment to authorise, please go to claim detail
          page and click on the 'Authorise treatment' button. Alternatively, you
          can click on the 'Make a claim' button from your Home page or 'My
          claims'
        </p>
      ),
      Format2: (
        <p>
          If you have a new treatment to authorise, please click on the 'Make a
          claim' button from your Home page or 'My claims'. Then select
          'Authorise a treatment or appointment'.
        </p>
      ),
      //for AGH/International members
      International: (
        <p>
          If you have a new treatment to authorise, please click on the 'Make a
          claim' button from your Home page or 'My claims'. Then select 'Check
          cover for treatment'.
        </p>
      )
    }
  },
  {
    Question: "How do I upload a new invoice for treatment?",
    Answer: {
      Any: (
        <p>
          If you have a new invoice to upload, please go to claim details page
          and click on the 'Upload invoice' button. Alternatively, you can click
          on the 'Make a claim' button from your Home page or 'My claims'.
        </p>
      ),
      Format2: (
        <p>
          If you have a new invoice to upload, please click on the 'Make a
          claim' button from your Home page or 'My claims'. Then select 'Claim
          back for payments you've made'.
        </p>
      )
    }
  },
  {
    Question: "How do I view payment details for my claim?",
    Answer: {
      Any: (
        <p>
          To view the payment details for your claims, please go to the claim
          details page for the claim you want to view. Then click on the 'View
          payments' button. You will be able to view details for any payments
          that we have assessed.
        </p>
      ),
      Format2: (
        <p>
          To view the payment details for your claims, please download the
          relevant benefit statement on 'My claims'. This will show what's been
          paid.
        </p>
      )
    }
  }
];
const HowToClaim = {
  heading: <h2>How to claim</h2>,
  description: (
    <p>
      Making a claim online is quick and easy. Follow the steps below, fill out
      the details about your claim and upload supporting documents. We’ll then
      get back to you to confirm approval or reimbursement.
    </p>
  ),
  claimProcessHeader: "How does the claim process work?",
  checkYourCoverDetail: {
    Format2: (
      <React.Fragment>
        <h4>Check your cover</h4>
        <p>
          Before making your claim, please check that you're covered. You can
          find this information in your{" "}
          <Link
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.CoverDocuments}
          >
            handbook
          </Link>
          .
        </p>
      </React.Fragment>
    ),
    Any: (
      <React.Fragment>
        <h4>Check your cover</h4>
        <p>
          Before making your claim, please check that you’re covered. You can do
          this on your{" "}
          <Link
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
            to={Paths.Cover}
          >
            cover
          </Link>{" "}
          page.
        </p>
      </React.Fragment>
    )
  },

  tellUsAboutYourClaimDetail: {
    International: (
      <React.Fragment>
        <h4>Tell us about your claim</h4>
        <p>
          Complete the details of your claim using our simple{" "}
          <Link
            to={Paths.MakeAClaim}
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          >
            online form
          </Link>
          . Please have details ready about your condition, treatment and
          specialist or healthcare provider.
        </p>
        <p>
          For upcoming treatment, please ensure you’ve pre-approved your claim
          with us before you visit your healthcare provider.
        </p>
        <p>
          For treatment you have had, please have your receipts or invoices
          ready to upload.
        </p>
      </React.Fragment>
    ),
    Any: (
      <React.Fragment>
        <h4>Tell us about your claim</h4>
        <p>
          Complete the details of your claim using our simple{" "}
          <Link
            to={Paths.MakeAClaim}
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          >
            online form
          </Link>
          . Please have details ready about your condition, treatment and
          specialist or healthcare provider.
        </p>
        <p>
          For upcoming treatment, please ensure you’ve an open referral from
          your GP and the referral letter ready to upload.
        </p>
        <p>
          For treatment you have had, please have your receipts or invoices
          ready to upload.
        </p>
      </React.Fragment>
    )
  },

  weWillGetBackToYouDetail: (
    <React.Fragment>
      <h4>We'll get back to you</h4>
      <p>
        Once we’ve reviewed the details of your claim, we’ll get back to you as soon as possible.
      </p>
      <p>
        For upcoming treatment, we’ll confirm if you can go ahead, or if we need
        any additional information. You’ll need to take your claim number to
        your appointment so the provider can send us the bill. If your
        specialist says you need further treatment, you’ll need to authorise
        this with us again.
      </p>
      <p>
        For treatment you have had, we'll pay the claim, provided you’re
        covered, or let you know if we need any further information.
      </p>
    </React.Fragment>
  ),

  paymentForTheTreatmentDetail: (
    <React.Fragment>
      <h4>Payment for the treatment</h4>
      <p>
        We normally settle bills directly with your treatment provider, if
        you’ve not already done so. We’ll let you know if you need to pay any
        excess or extra costs. Where you have already paid your provider, we’ll
        reimburse you, provided you’re covered.
      </p>
    </React.Fragment>
  ),
  headingLinkTo: Paths.Help,
  headingLinkText: "Help",
  moreHelpLinkTo: Paths.Help,
  moreHelpLinkText: "View more help",
  helpSet: {
    Any: GenericHelpSet,
    International: GenericHelpSet,
    Format2: GenericHelpSet
  },
  helpSetEP:(AuthUrl, ClaimBackUrl,IsInternalView)=>[
    {
      Question: "How do I authorise a new treatment?",
      Answer: {
        Any: IsInternalView?(
          <p>
            If you have a new treatment to authorise, please {"  "}
            <Link to="/" 
            className={linkStyles.disabled} 
            onClick={ (event) => event.preventDefault() }>
            contact us to check if your membership covers your treatment.{" "}
            </Link>
          </p>
        ):(
          <p>
              If you have a new treatment to authorise, please {"  "}
              <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={AuthUrl}
              target="_blank"
              rel="noopener"
            >
              contact us to check if your membership covers your treatment.{" "}
            </a>
            </p>
        ),
        Format2: IsInternalView?(
          <p>
            If you have a new treatment to authorise, please {"  "}
            <Link to="/" 
            className={linkStyles.disabled} 
            onClick={ (event) => event.preventDefault() }>
            contact us to check if your membership covers your treatment.{" "}
            </Link>
          </p>
        ):(
          <p>
              If you have a new treatment to authorise, please {"  "}
              <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={AuthUrl}
              target="_blank"
              rel="noopener"
            >
              contact us to check if your membership covers your treatment.{" "}
            </a>
            </p>
        ),
        //for AGH/International members
        International: (
          <p>
            If you have a new treatment to authorise, please click on the 'Make a
            claim' button from your Home page or 'My claims'. Then select 'Check
            cover for treatment'.
          </p>
        )
      }
    },
    {
      Question: "How do I upload a new invoice for treatment?",
      Answer: {
        Any: IsInternalView?(
          <p>
            If you have a new invoice to send us, you can {"  "}
            <Link to="/" 
            className={linkStyles.disabled} 
            onClick={ (event) => event.preventDefault() }>
            upload your documents here.{" "}
            </Link>
          </p>
          ):(
          <p>
              If you have a new invoice to send us, you can {"  "}
              <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={ClaimBackUrl}
              target="_blank"
              rel="noopener"
            >
              upload your documents here.{" "}
            </a>
            </p>
        ),
        Format2: IsInternalView?(
          <p>
            If you have a new invoice to send us, you can {"  "}
            <Link to="/" 
            className={linkStyles.disabled} 
            onClick={ (event) => event.preventDefault() }>
            upload your documents here.{" "}
            </Link>
          </p>
          ):(
          <p>
              If you have a new invoice to send us, you can {"  "}
              <a
              className={"hol-link " + layoutStyle.anchorDecorationUnderline}
              href={ClaimBackUrl}
              target="_blank"
              rel="noopener"
            >
              upload your documents here.{" "}
            </a>
            </p>
        )
      }
    },
    {
      Question: "How do I view payment details for my claim?",
      Answer: {
        Any: (
          <p>
            To view the payment details for your claims, please go to the claim
            details page for the claim you want to view. Then click on the 'View
            payments' button. You will be able to view details for any payments
            that we have assessed.
          </p>
        ),
        Format2: (
          <p>
            To view the payment details for your claims, please download the
            relevant benefit statement on 'My claims'. This will show what's been
            paid.
          </p>
        )
      }
    }
  ],  
  AskMedExpert: {
    IconSrc: {
      Any: MedExpertBannerSrc,
      HOL: MedExpertBannerHolSrc
    },
    IconSrcMobile: {
      Any: MedExpertPromoSrcMobile,
      HOL: MedExpertBannerHolSrc
    },
    Heading: {
      Any: "24/7 health support line",
      HOL: "24/7 health support line"
    },
    Description:
      "Speak to one of our expert nurses, counsellors, midwives and pharmacists about your health, anytime, either online or on the phone.",
    LinkText: {
      Any: "24/7 health support line",
      HOL: "24/7 health support line"
    },
    LinkTo: Paths.AskAMedicalExpert,
    ExternalLinkTo: null
  },
  travelHeading: <h2>Travel cover - How to claim</h2>,
  travelDescription: (
    <p>
      Making a claim is quick and easy. Simply follow the steps below to send us
      your claim details and be sure to include your supporting documents with
      your form. We'll then get back to you as soon as we've assessed your
      claim, or if we require any additional information to help us with this.
    </p>
  ),
  travelClaimProcessHeader: "How does the claim process work?",
  RequestTravelClaimForm: (
    <React.Fragment>
      <h4>Call our travel claims team</h4>
      <p>Request a claim form by calling our helpline on:</p>
      <p>
        0345 602 0303 (from the UK)
        <br />
        +44 (0)1892 614200 (from overseas)
      </p>
      <p>
        Our opening hours are from 8am-8pm, Monday to Friday and 9am to 5pm on
        Saturday.
      </p>
    </React.Fragment>
  ),
  CompleteTravelClaimForm: (
    <React.Fragment>
      <h4>Complete the claim form</h4>
      <p>
        Submit your claims form within 31 days of your return to the UK (unless
        this is not reasonably possible).
        <br />
        Make sure all the relevant information is enclosed by including the
        original accounts, bills or receipts and proof of travel, such as a
        booking invoice or airline tickets.
        <br />
        Your claim may be delayed if you don’t provide these details.
      </p>
    </React.Fragment>
  ),
  SubmitTravelClaimForm: (
    <React.Fragment>
      <h4>Send us your claim</h4>
      <p>Send the completed form and documents to us at:</p>
      <p>
        {RebrandHelper.getAxaBrandName()} Travel,
        <br />
        PO Box 400,
        <br />
        Tunbridge Wells,
        <br />
        Kent
        <br />
        TN1 2WJ
      </p>
      <p>
        We’ll assess your claim and send you a claims benefit statement
        confirming the amount of benefit paid for each travel claim.{" "}
      </p>
      <p>
        We may record and/or monitor calls for quality assurance, training and
        as a record of our conversation.
      </p>
    </React.Fragment>
  )
};

export default HowToClaim;
